export default __webpack_public_path__ + "static/logo-hover-138518759c3b278d08d45d49195a3abf.svg";